import React from 'react';
import styles from './AsSeenOn.module.css';
import authorityMagazineImg from '../../../assets/Authority-Magazine.webp';
import ceoWeeklyImg from '../../../assets/CEO-Weekly.png';
import bodyNetworkImg from '../../../assets/Body-Network.png';
import medicalNewsTodayImg from '../../../assets/MedicalNewsToday.png';
import healthcareItImg from '../../../assets/healthcare-it-today.png';

const PRESS_LOGOS = [
    {
        name: 'Authority Magazine',
        image: authorityMagazineImg,
        url: 'https://medium.com/authority-magazine/paul-moss-and-antoni-adamrovich-of-tb2-health-49f6d473922c',
    },
    {
        name: 'CEO Weekly',
        image: ceoWeeklyImg,
        url: 'https://ceoweekly.com/meet-paul-moss-ceo-and-co-founder-of-tb2-health/',
    },
    {
        name: 'Body Network',
        image: bodyNetworkImg,
        url: 'https://bodynetwork.com/weight-loss-maintenance-tips-after-ozempic/',
    },
    {
        name: 'Medical News Today',
        image: medicalNewsTodayImg,
        url: 'https://www.medicalnewstoday.com/articles/how-semaglutide-drugs-such-as-ozempic-can-help-with-long-term-weight-loss-and-heart-health',
    },
    {
        name: 'Healthcare IT Today',
        image: healthcareItImg,
        url: 'https://www.healthcareittoday.com/2024/05/01/lean-digital-behavior-change-for-weight-and-obesity/',
    },
];

function AsSeenOn() {
    return (
        <section className={styles.proofBlock}>
            <div className={styles.proofInner}>
                <div className={styles.proofPress}>
                    <span className={styles.pressLabel}>As seen on</span>
                    <div className={styles.pressLogos}>
                        {PRESS_LOGOS.map((logo) => (
                            <a
                                key={logo.name}
                                href={logo.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={logo.name}
                            >
                                <img src={logo.image} alt={logo.name} />
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AsSeenOn;
